import {
    Assignment,
    AvTimer,
    Battery20,
    BatteryAlert,
    LocalDrink,
    LocalGasStation,
    PermScanWifi,
    Rotate90DegreesCcw,
} from '@mui/icons-material';
import { Icon, IconProps, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';

export interface IssueCauseIconProps extends IconProps {
    /** The issue cause/trigger. */
    trigger: string;
}

export const IssueCauseIcon = ({ trigger, ...props }: IssueCauseIconProps) => {
    const [iconElem, setIconElem] = useState<JSX.Element>(<div />);
    const [tooltip, setTooltip] = useState('');

    useEffect(() => {
        if (trigger) {
            if (trigger === 'battery_crit') {
                setIconElem(<BatteryAlert data-testid="BatteryCritIcon" />);
                setTooltip('Battery Crit');
            } else if (trigger === 'battery_warn') {
                setIconElem(<Battery20 data-testid="BatteryWarnIcon" />);
                setTooltip('Battery Warn');
            } else if (trigger === 'offline') {
                setIconElem(<PermScanWifi data-testid="OfflineIcon" />);
                setTooltip('Offline');
            } else if (trigger === 'missing_address') {
                setIconElem(<Assignment data-testid="MissingAddressIcon" />);
                setTooltip('Missing Address');
            } else if (trigger === 'missing_orientation') {
                setIconElem(
                    <Rotate90DegreesCcw data-testid="MissingOrientationIcon" />
                );
                setTooltip('Missing Orientation');
            } else if (trigger === 'missing_capacity') {
                setIconElem(<LocalDrink data-testid="MissingCapacityIcon" />);
                setTooltip('Missing Capacity');
            } else if (trigger === 'fill') {
                setIconElem(<LocalGasStation data-testid="FillIcon" />);
                setTooltip('Fill');
            } else if (trigger === 'stuck_gauge') {
                setIconElem(<AvTimer data-testid="StuckGaugeIcon" />);
                setTooltip('Stuck Gauge');
            } else {
                setIconElem(<div />);
                setTooltip('');
            }
        }
    }, [trigger]);

    return (
        <div data-testid="IssueCauseIcon">
            <Tooltip title={tooltip}>
                <Icon {...props}>{iconElem}</Icon>
            </Tooltip>
        </div>
    );
};
